import React from "react";
import {List} from "../modules/Tenants";

export function TenantsListPage() {
  return (
    <List />
  );
}
